export default function calculateHeights(
  data: { value: number; bgColor: string; name: string }[]
) {
  const MAX_HEIGHT = 120;
  const MIN_HEIGHT = 30;
  const TOTAL_DROP = MAX_HEIGHT - MIN_HEIGHT;

  // value DESC
  const sorted = [...data].sort((a, b) => b.value - a.value);

  // ardışık value farkları
  const valueDiffs = [];
  for (let i = 0; i < sorted.length - 1; i++) {
    valueDiffs.push(sorted[i].value - sorted[i + 1].value);
  }

  const totalValueDiff = valueDiffs.reduce((a, b) => a + b, 0);

  // diffHeight'ları hesapla (90 px paylaştırılıyor)
  const diffHeights = valueDiffs.map((diff) =>
    totalValueDiff === 0
      ? TOTAL_DROP / valueDiffs.length
      : (diff / totalValueDiff) * TOTAL_DROP
  );

  // zincirli height hesaplama
  let currentHeight = MAX_HEIGHT;

  const result = sorted.map((item, i) => {
    const heightTotal = Math.round(currentHeight);
    const diffHeight = i < diffHeights.length ? Math.round(diffHeights[i]) : 0;

    currentHeight -= diffHeight;

    return {
      ...item,
      heightTotal,
      diffHeight,
    };
  });

  // sondan önceki elemanı garantiye al
  const isDiffOk =
    result[result.length - 2].heightTotal -
      result[result.length - 2].diffHeight ===
    MIN_HEIGHT;
  if (!isDiffOk) {
    result[result.length - 2].diffHeight =
      result[result.length - 2].heightTotal - MIN_HEIGHT;
  }

  // son elemanı garantiye al
  result[result.length - 1].heightTotal = MIN_HEIGHT;
  result[result.length - 1].diffHeight = 0;

  return result;
}
